import client from './client';

export const login = (username: string, password: string) =>
  client.post('/api/admin/login', { username, password });

export const me = () => client.get('/api/admin/me');

export const logout = () => client.post('/api/admin/logout');
